export interface ReferralCodeRow {
  id?: string;
  referrer_id?: string;
  code: string;
  active: boolean;
  reward_amount: number | null;
  monthly_cap: number | null;
  created_at?: string;
}

interface ReferralDefaults {
  reward_amount?: number | null;
  monthly_cap?: number | null;
}

export interface ReferralEditorState {
  rewardAmountInput: string;
  monthlyCapInput: string;
  active: boolean;
}

const REFERRAL_CODE_ALPHABET = "ABCDEFGHJKLMNPQRSTUVWXYZ23456789";
const REFERRAL_CODE_LENGTH = 8;

export const generateReferralCode = (): string => {
  const bytes = new Uint8Array(REFERRAL_CODE_LENGTH);
  crypto.getRandomValues(bytes);
  return Array.from(
    bytes,
    (byte) => REFERRAL_CODE_ALPHABET[byte % REFERRAL_CODE_ALPHABET.length]
  ).join("");
};

export const getReferralEditorState = ({
  defaults,
  referralCode,
}: {
  defaults?: ReferralDefaults | null;
  referralCode?: ReferralCodeRow | null;
}): ReferralEditorState => ({
  rewardAmountInput: Number(
    referralCode?.reward_amount ?? defaults?.reward_amount ?? 5
  ).toFixed(2),
  monthlyCapInput: String(
    referralCode?.monthly_cap ?? defaults?.monthly_cap ?? 5
  ),
  active: referralCode?.active ?? true,
});
